import { ListEntityType } from "../../enums/list-entity-type";
import { CardTracker } from "./card-tracker";
export class UniversityCardTracker extends CardTracker {
    constructor(tracker) {
        super(tracker);
    }
    getListEntityType() {
        return ListEntityType.ORGANISATION;
    }
}
